import React from 'react';
import bridePic from '../../public/static/IMG_4437.png';
import groomPic from '../../public/static/IMG_6176.png';
import napa from  '../../public/static/napa.png';
import romania from  '../../public/static/romania.png';
import sedona from  '../../public/static/sedona.png';
import space_needle from  '../../public/static/space_needle.png';
import yoda from  '../../public/static/yoda.png';
import ariel from  '../../public/static/ariel.png';
import christmas from  '../../public/static/christmas.png';
import fremont from  '../../public/static/fremont.png';
import rings from   '../../public/static/ring.png';
import troll from   '../../public/static/troll.png';
import proposal from  '../../public/static/proposal.png';
import surgery from  '../../public/static/surgery.png';
import hospital from '../../public/static/hospital.png';
import chelan from  '../../public/static/chelan.png';

const brideName = 'Samara';
const groomName = 'Gabriel';

const config = {
  site: {
    backgroundColor: '#f8f8f8',
    navColor: '#D95E39',
    textColor: '#001f3f',
    title: `${brideName} and ${groomName} Wedding Site`,
    description: `${brideName} and ${groomName} wedding website`,
    keywords: `${brideName}, ${groomName}, wedding website`,
  },
  img: {
      bridePic,
      groomPic,
      napa,
      romania,
      sedona,
      space_needle,
      yoda,
      ariel,
      christmas,
      fremont,
      rings,
      troll,
      proposal,
      chelan,
      surgery,
      hospital,
  },
  wedding: {
    date: '7/18/2020',
    location: 'Seattle, WA',
    startTime: '6:00pm',
    endTime: '10:00pm',
    arrivalTime: '6:00pm',
  },
  welcomeParty: {
    date: '1/1/2017',
    startTime: '8:00',
    endTime: '11:00pm',
    location: 'Location TBD',
  },
  afterParty: {
    startTime: '10:00pm',
    endTime: 'Midnight',
    location: 'Location TBD',
  },
  brunch: {
    date: '7/19/2020',
    startTime: '10:00am',
    endTime: 'Noon',
    location: 'Location TBD',
  },
  personalInfo: {
    bride: brideName,
    groom: groomName,
    description: (
      <div>
        <p>We are very excited to have you at our wedding!</p>
        <p>
          Please check back here soon the live feed
        </p>
      </div>
    ),
  },
  travel: {
    airports: [
      {
        name: 'Oakland',
        code: 'OAK',
        distance: '1 hour, 30 min',
      },
      {
        name: 'San Francisco',
        code: 'SFO',
        distance: '1 hour, 30 min',
      },
    ],
  },
  navBarLinks: [
    {
      link: '/about',
      title: 'ABOUT US',
    },
    {
      link: '/schedule',
      title: 'SCHEDULE',
    },
    {
      link: '/live',
      title: 'LIVE STREAM',
    },
    {
      link: '/contact',
      title: 'CONTACT',
    },
  ],
  venue: {
    title: 'The Baker Residence',
    physicalAddr: '1600 Pennsylvania Ave NW, Washington, DC',
    webAddr: 'https://www.whitehouse.gov/',
    googleMapsLink:
      'https://www.google.com/maps/place/The+White+House,+1600+Pennsylvania+Ave+NW,+Washington,+DC+20500/@38.8976094,-77.0389236,17z/data=!3m2!4b1!5s0x89b7b7bce16040c9:0xb825fcec8d0b4d30!4m5!3m4!1s0x89b7b7bce1485b19:0x9fc7bf09fd5d9daf!8m2!3d38.8976633!4d-77.0365739',
    drivingNotes: 'Lyft and Uber is available in the area.',
  },
  hotel: {
    title: 'Oxford Suites',
    blockDescription: 'Hotel block information coming soon.',
    listOfHotelsInArea: [
      {
        title: 'This is a fake hotel',
        link: 'link here',
      },
      {
        title: 'Another fake hotel',
        link: 'another link here',
      },
    ],
  },
  surroundingArea: {
    name: 'Washington D.C.',
    airbnbLink: 'https://www.airbnb.com/s/Washington--DC--United-States/all',
  },
  registries: [],
  live: {
    formHTML: (
        <iframe
            //src="https://player.twitch.tv/?video=v677887843&parent=localhost"
            src="https://player.twitch.tv/?channel=samara_and_gabriel_2020&parent=samara-and-gabriel.com"
            height="360"
            width="640"
            frameBorder="0"
            scrolling="no"
            allowFullScreen="true">
        </iframe>
    ),
  },
};

export default config;



// WEBPACK FOOTER //
// ./src/utils/config.js